/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'info-log': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M921.6 819.2H102.4a102.4 102.4 0 000 204.8h819.2a102.4 102.4 0 000-204.8m0-409.6H614.4a102.4 102.4 0 000 204.8h307.2a102.4 102.4 0 000-204.8M614.4 204.8h307.2a102.4 102.4 0 000-204.8H614.4a102.4 102.4 0 000 204.8m-512 409.6H256A102.4 102.4 0 00358.4 512V102.4A102.4 102.4 0 00256 0H102.4A102.4 102.4 0 000 102.4V512a102.4 102.4 0 00102.4 102.4"/>'
  }
})
